"use client";

import { c as _c } from "react/compiler-runtime";
import MediaTypeBadge from "@/components/drops/media/MediaTypeBadge";
import NFTImage from "@/components/nft-image/NFTImage";
import NFTImageBalance from "@/components/nft-image/NFTImageBalance";
import type { NFTWithMemesExtendedData } from "@/entities/INFT";
import { VolumeType } from "@/entities/INFT";
import { numberWithCommas, printMintDate } from "@/helpers/Helpers";
import { getNftMimeType } from "@/helpers/nft.helpers";
import { MemesSort } from "@/types/enums";
import Link from "next/link";
function getVolume(nft: NFTWithMemesExtendedData, volumeType: VolumeType) {
  let vol = 0;
  switch (volumeType) {
    case VolumeType.HOURS_24:
      vol = nft.total_volume_last_24_hours;
      break;
    case VolumeType.DAYS_7:
      vol = nft.total_volume_last_7_days;
      break;
    case VolumeType.DAYS_30:
      vol = nft.total_volume_last_1_month;
      break;
    case VolumeType.ALL_TIME:
      vol = nft.total_volume;
      break;
  }
  if (vol > 0) {
    return `${numberWithCommas(Math.round(vol * 100) / 100)} ETH`;
  }
  return "-";
}
function getNftMetricText(nft: NFTWithMemesExtendedData, sort: MemesSort, volumeType: VolumeType) {
  switch (sort) {
    case MemesSort.AGE:
    case MemesSort.MEME:
      return printMintDate(nft.mint_date);
    case MemesSort.EDITION_SIZE:
      return `Edition Size: ${numberWithCommas(nft.supply)}`;
    case MemesSort.TDH:
      return `TDH: ${numberWithCommas(Math.round(nft.boosted_tdh))}`;
    case MemesSort.HODLERS:
      return `Collectors: ${numberWithCommas(nft.hodlers)}`;
    case MemesSort.UNIQUE_PERCENT:
      return `Unique: ${Math.round(nft.percent_unique * 100 * 10) / 10}%`;
    case MemesSort.UNIQUE_PERCENT_EX_MUSEUM:
      return `Unique Ex-Museum: ${Math.round(nft.percent_unique_cleaned * 100 * 10) / 10}%`;
    case MemesSort.FLOOR_PRICE:
      return nft.floor_price > 0 ? `Floor Price: ${numberWithCommas(Math.round(nft.floor_price * 1000) / 1000)} ETH` : "Floor Price: N/A";
    case MemesSort.HIGHEST_OFFER:
      return nft.highest_offer > 0 ? `Highest Offer: ${numberWithCommas(Math.round(nft.highest_offer * 1000) / 1000)} ETH` : "Highest Offer: N/A";
    case MemesSort.MARKET_CAP:
      return nft.market_cap > 0 ? `Market Cap: ${numberWithCommas(Math.round(nft.market_cap * 100) / 100)} ETH` : "Market Cap: N/A";
    case MemesSort.VOLUME:
      return `Volume (${volumeType}): ${getVolume(nft, volumeType)}`;
  }
}
export default function TheMemesCard(t0) {
  const $ = _c(32);
  const {
    nft,
    sort,
    volumeType,
    hasConnectedProfile
  } = t0;
  let t1;
  if ($[0] !== nft) {
    t1 = getNftMimeType(nft);
    $[0] = nft;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const mediaMimeType = t1;
  let t2;
  if ($[2] !== nft || $[3] !== sort || $[4] !== volumeType) {
    t2 = getNftMetricText(nft, sort, volumeType);
    $[2] = nft;
    $[3] = sort;
    $[4] = volumeType;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const metricText = t2;
  const t3 = `/the-memes/${nft.id}`;
  let t4;
  if ($[6] !== nft) {
    t4 = <div className="tw-relative tw-mb-2 tw-bg-iron-950"><NFTImage nft={nft} animation={false} height={300} showThumbnail={true} showBalance={false} /></div>;
    $[6] = nft;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== hasConnectedProfile || $[9] !== nft.contract || $[10] !== nft.id) {
    t5 = hasConnectedProfile && <div className="tw-flex tw-justify-center tw-px-4"><div className="tw-inline-flex tw-h-7 tw-min-w-0 tw-flex-none tw-items-center tw-rounded-md tw-border tw-border-solid tw-border-iron-800 tw-bg-transparent tw-px-3 tw-text-iron-400 [&>span]:tw-overflow-hidden [&>span]:tw-text-ellipsis [&>span]:tw-text-[0.65625rem] [&>span]:tw-font-medium [&>span]:tw-uppercase [&>span]:tw-leading-none [&>span]:tw-tracking-[0.1em]"><NFTImageBalance contract={nft.contract} tokenId={nft.id} height={300} inline={true} /></div></div>;
    $[8] = hasConnectedProfile;
    $[9] = nft.contract;
    $[10] = nft.id;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== mediaMimeType || $[13] !== nft.contract || $[14] !== nft.id) {
    t6 = mediaMimeType && <MediaTypeBadge mimeType={mediaMimeType} dropId={`${nft.contract}-${nft.id}`} size="sm" className="tw-mr-3 tw-inline-flex tw-align-[-0.25rem]" iconClassName="tw-size-5 tw-inline" />;
    $[12] = mediaMimeType;
    $[13] = nft.contract;
    $[14] = nft.id;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== nft.id || $[17] !== nft.name) {
    t7 = <span className="tw-relative tw-top-0.5">#{nft.id} - {nft.name}</span>;
    $[16] = nft.id;
    $[17] = nft.name;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] !== t6 || $[20] !== t7) {
    t8 = <div className="tw-w-full tw-max-w-full tw-text-center tw-text-sm tw-font-semibold tw-leading-snug tw-text-iron-100">{t6}{t7}</div>;
    $[19] = t6;
    $[20] = t7;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  let t9;
  if ($[22] !== metricText) {
    t9 = <div className="tw-min-h-5 tw-w-full tw-text-center tw-text-xs tw-leading-5 tw-text-iron-500">{metricText}</div>;
    $[22] = metricText;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  let t10;
  if ($[24] !== t8 || $[25] !== t9) {
    t10 = <div className="tw-flex tw-min-w-0 tw-flex-col tw-items-center tw-gap-y-2 tw-px-2 tw-pb-4 tw-pt-4 tw-text-center md:tw-px-4">{t8}{t9}</div>;
    $[24] = t8;
    $[25] = t9;
    $[26] = t10;
  } else {
    t10 = $[26];
  }
  let t11;
  if ($[27] !== t10 || $[28] !== t3 || $[29] !== t4 || $[30] !== t5) {
    t11 = <Link href={t3} className="tw-group tw-block tw-min-w-0 tw-overflow-hidden tw-rounded-xl tw-border tw-border-solid tw-border-white/10 tw-bg-iron-950 tw-text-iron-100 tw-no-underline tw-transition tw-duration-200 hover:tw-border-white/20 hover:tw-bg-iron-900/50 focus-visible:tw-outline focus-visible:tw-outline-2 focus-visible:tw-outline-primary-400">{t4}{t5}{t10}</Link>;
    $[27] = t10;
    $[28] = t3;
    $[29] = t4;
    $[30] = t5;
    $[31] = t11;
  } else {
    t11 = $[31];
  }
  return t11;
}